export const INIT = "resultIndexReport/INIT";
export const SET = "resultIndexReport/SET";
export const SET_ERRORS = "resultIndexReport/SET_ERRORS";

export const initResultIndexReport = () => ({
  type: INIT
});
export const setResultIndexReport = res => ({
  type: SET,
  res
});
export const setErrors = errors => ({
  type: SET_ERRORS,
  errors
});

const initialState = {
  resultIndexByQuestion: [],
  questions: {},
  measureSize: {},
  errors: []
};

const resultIndexReport = (state = initialState, action) => {
  switch (action.type) {
    case INIT: {
      return {
        ...initialState
      };
    }
    case SET: {
      return { ...action.res };
    }
    case SET_ERRORS: {
      return { ...state, errors: action.errors };
    }
    default:
      return state;
  }
};

export default resultIndexReport;



// WEBPACK FOOTER //
// ./src/redux/modules/resultIndexReport.js